import { ArrowUpRight, MapPin } from "lucide-react";
import { locations } from "../content/siteContent";

type LocationGridProps = {
  compact?: boolean;
};

export function LocationGrid({ compact = false }: LocationGridProps) {
  return (
    <div className={`location-grid${compact ? " location-grid--compact" : ""}`}>
      {locations.map((location) => (
        <article className="location-item" key={location.title}>
          <h3>{location.title}</h3>
          <div className="map-frame">
            <iframe
              src={location.embedUrl}
              title={location.mapTitle}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
            />
          </div>
          <div className="map-caption">
            <div>
              <MapPin aria-hidden="true" />
              <span>{location.details[0] || location.title}</span>
            </div>
            <a href={location.directionsUrl} target="_blank" rel="noreferrer" data-target>
              Οδηγίες
              <ArrowUpRight aria-hidden="true" />
            </a>
          </div>
          {location.details.length > 1 ? (
            <div className="location-details">
              {location.details.slice(1).map((detail) => (
                <p key={detail}>{detail}</p>
              ))}
            </div>
          ) : null}
        </article>
      ))}
    </div>
  );
}
